<template lang="html">
  <section class="distribution-channels-page">
    <div class="distribution-channels-resullts">
      <distribution-channel-card
        :distribution-channel="dt"
        v-for="dt in distributionChannels"
        :key="dt.uuid"
      />
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME } from "@/static/global-variables";
  import DistributionChannelCard from "@/components/custom-display-elements/distribution-channels/DistributionChannelCard";

  export default  {
    name: 'distribution-channels-page',
    components: {
      DistributionChannelCard
    },
    computed: {
      distributionChannels() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNELS_SUMMARY];
      }
    }
  }
</script>

<style scoped lang="scss">
  .distribution-channels-page {
    padding: 1rem;
    .distribution-channels-resullts {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }
  }
</style>
